import { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import TransactionNodes from './TransactionNodes';
import { handleSnackBar, toggleRightDrawer, setReRender, toggleBottomDrawer } from '../../../store/global/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

import { invokePostService } from "../../../store/global/actions";

import UpdateCancel from '../../atoms/buttons/UpdateCancel';

export default function AddClusterletNodes({transaction, existingNodes, onClose, onCompletion }) {
    // console.log('AddClusterletNodes------------------', {existingNodes})
    const dispatch = useDispatch();
    const history = useHistory();

    const currentUrl = window.location.href;
    const [slug, blueprintID] = currentUrl.split('/').slice(4);

    const [nodesLoading, setNodesLoading] = useState(false);
    const [selectedNodes, setSelectedNodes] = useState( []);
    const [isUpdating, setIsUpdating] = useState(false);

   
    const onAddClusterlets = () => {
        // console.log("onAddClusterlets------------------------", {existingNodes, selectedNodes})
        setIsUpdating(true);

        const updatedNodeSet = [...existingNodes, ...selectedNodes]

        const editTransaction = {
            ...transaction,
            clusterlets: updatedNodeSet.map((node, key) => ({ id: node._id, order: key, category: node.category !== undefined ? node.category : 'userdefined' }))
        }

        dispatch(invokePostService('updateTransactionNodes', { nodes: editTransaction.clusterlets }, [transaction._id]))
            .then((response) => {
                if (response.data) {
                    dispatch(setReRender());
                    onClose();
                    dispatch(handleSnackBar({ open: true, message: `Transaction updated`, severity: "success" }));
                } else if (response.code === 254) {
                    // dispatch(toggleRightDrawer());
                } else if (response?.status === false && response?.code === 255 && response.transactionNotFound === true) {
                    history.push(`/blueprint/${slug}/${blueprintID}/system-model`);
                    dispatch(toggleBottomDrawer());
                }
                setIsUpdating(false);
            })
            .catch(error => {
                console.error(`Updating transaction nodes failed. ${error}`);
            })
    }

    const onCencel = () => {
        onClose();
    }



    return (
        <Grid container direction={"row"} spacing={3}>

            <TransactionNodes existingNodes={existingNodes} setNodesLoading={setNodesLoading} selectedIcons={selectedNodes} setSelectedIcons={setSelectedNodes}  />
           
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                <UpdateCancel onUpdate={onAddClusterlets} onCancel={onCencel} updateDisable={isUpdating || nodesLoading} />
            </Grid>

        </Grid>
    )
}